import type { GuestSettings } from "./guests"

export interface Building {
  id: string
  name: string
  address: string
  city: string
  zipCode: string
  totalRooms: number
  isArchived: boolean
  createdAt: string
  guestSettings?: GuestSettings
}

// Greek-aware, number-aware ordering ("Κτίριο 2" before "Κτίριο 10") for every building list
export const compareBuildingNames = (a: string, b: string) =>
  a.localeCompare(b, "el", { numeric: true, sensitivity: "base" })

export const sortBuildingsByName = <T extends { name: string }>(buildings: T[]): T[] =>
  [...buildings].sort((a, b) => compareBuildingNames(a.name || "", b.name || ""))
